export default {
  'todos.categories.phone': 'Phone',
  'todos.categories.email': 'Email',
  'todos.categories.meeting': 'Meeting',
  'todos.categories.task': 'Task',
  'todos.categories.note': 'Note',
  'todos.batch_complete.success': 'All todos completed',
  'todos.batch_complete.error': 'Batch complete failed',
  'todos.complete_all': 'Complete All',
  'todos.all_completed': 'All todos completed',
  'todos.no_data': 'No todo data',
  'todos.batch_complete.confirm.title': 'Confirm Complete All',
  'todos.batch_complete.confirm.content': 'Are you sure to complete {count} todo items?',
  'todos.no_selection': 'Please select todos to complete',
  'todos.selected_count': 'Selected {count} items',
  'todos.complete_selected': 'Complete Selected',
  'todos.show_my_todos': 'Show My Todos',
  'todos.show_operator': 'Show Todos by Operator',
  'todos.show_member': 'Show Todos by Member',
};
